import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { DomainDetail } from '@/features/domains/DomainDetail';
import { useTenant } from '@/lib/tenant';

function DomainDetailRoute() {
  const { slug, id } = Route.useParams();
  const { setSlug } = useTenant();
  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);
  return <DomainDetail slug={slug} domainId={id} />;
}

export const Route = createFileRoute('/tenants/$slug/domains/$id')({
  component: DomainDetailRoute,
});
